module.exports = __webpack_public_path__ + "fonts/Raleway-Regular.52c9416c.ttf";